/* eslint-disable no-unused-expressions */
import axios from 'axios';

export default class AuthorityService {
  public static authorities(): Promise<string[]> {
    return axios.get('/project-api/me/authorities')
      .then(({ data }: any) => data);
  }
}
